import browserStoragePrefix from '../../../../../shared/browserStoragePrefix';

storageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

export default function storageConfig($localStorageProvider, $sessionStorageProvider) {
    $localStorageProvider.setKeyPrefix(browserStoragePrefix);
    $sessionStorageProvider.setKeyPrefix(browserStoragePrefix);
}
